<template>
  <w-row
    justify="center"
    class="flex-grow-0 mt-4"
  >
    <w-column class='pt-0 pb-0'>
      <SearchFilterBar
        :key="componentKey"
        ref="searchFilterBar"
        :concept='concept'
        :does-table-exists='doesTableExists'
        :filters='filters'
        :filter-card-state='filterCardState'
        :preset='preset'
        :orderd-filters='orderdFilters'
        :not-visible-filters='notVisibleFilters'
        :name='name'
        :save-columns='saveColumns'
        :is-default='isDefault'
        :get-table-state='getTableState'
        :set-preset-obj='setPresetObj'
        class="w-table-module__search-bar"
        @set:filter='(keyValuePair) => $emit("set:filter", keyValuePair)'
        @update:filter-card-state='(newfilterCardState) => $emit("update:filter-card-state", newfilterCardState)'
        @update:preset='(newPreset) => $emit("update:preset", newPreset)'
        @update:orderd-filters='(newOrderdFilters) => $emit("update:orderd-filters", newOrderdFilters)'
        @update:not-visible-filters='(newNotVisibleFilters) => $emit("update:not-visible-filters", newNotVisibleFilters)'
        @update:name='(newName) => $emit("update:name", newName)'
        @update:save-columns='(newSaveColumns) => $emit("update:save-columns", newSaveColumns)'
        @update:is-default='(newIsDefault) => $emit("update:is-default", newIsDefault)'
      >
        <template slot="prependSearchFilter">
          <slot name="prependSearchFilter" />
        </template>

        <slot name="searchFilter" />

        <template slot="groupSearchFilter">
          <slot name="groupSearchFilter" />
        </template>
      </SearchFilterBar>
    </w-column>
  </w-row>
</template>

<script>
export default {
  name: 'BaseLevelFilterContainer',
  components: {
    SearchFilterBar: () => import('@/components/base_components/SearchFilterBar')
  },
  props: {
    // data
    concept: { type: String, required: true, default: '' },
    filters: { type: Object, required: false },
    filterCardState: { type: String, required: true },
    preset: { type: Object, required: true },
    orderdFilters: { type: Array, required: true },
    notVisibleFilters: { type: Array, required: true },
    name: { type: String, required: true },
    saveColumns: { type: Boolean, required: true },
    isDefault: { type: Boolean, required: true },
    // flags
    doesTableExists: { type: Boolean, required: true },
    // handler
    getTableState: { type: Function, required: true },
    setPresetObj: { type: Function, required: true }
  },
  data() {
    return {
      componentKey: 1
    }
  },
};
</script>
